import { RepresentationType, SelectionType } from '../../../../bom/constants';

import GraphicMultiSelectQuestion from '../GraphicMultiSelectQuestion';
import GraphicParentChildQuestion from '../GraphicParentChildQuestion';
import PropTypes from 'prop-types';
import React from 'react';
import SingleSelectQuestion from '../SingleSelectQuestion';
import { getQuestions } from '../../../../bom/selectors';
import { useSelector } from 'react-redux';

const QuestionList = ({ feedback, resetFeedback }) => {
  const questions = useSelector(getQuestions);

  return (
    <>
      {questions.map((question) =>
        question.selectionType === SelectionType.SINGLE ? (
          <SingleSelectQuestion
            key={question.code}
            feedback={feedback}
            question={question}
            resetFeedback={resetFeedback}
          />
        ) : question.representationType === RepresentationType.GENERAL ? (
          <GraphicMultiSelectQuestion
            key={question.code}
            feedback={feedback}
            question={question}
            resetFeedback={resetFeedback}
          />
        ) : (
          <GraphicParentChildQuestion
            key={question.code}
            feedback={feedback}
            parentQuestion={question}
            resetFeedback={resetFeedback}
          />
        )
      )}
    </>
  );
};

QuestionList.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default QuestionList;
